import { makeStyles } from "@fluentui/react-components";

export const useSearchNavigationStyles = makeStyles({
  searchInfoContainer: {
    alignItems: "center",
    display: "flex",
    gap: "12px",
  },

  matchCount: {
    fontSize: "12px",
  },

  smallButton: {
    padding: "0px",
    minWidth: "20px",
    maxWidth: "20px",
  },
});
